"use client";

import { type RefObject, useEffect, useRef } from "react";
import { focusEditableControlAtStart } from "./focus";

/**
 * When `active` becomes true, focus the control at the start of its value
 * (after paint so the field exists in the DOM).
 */
export function useFocusEditableControlWhen(
	active: boolean,
	ref: RefObject<HTMLInputElement | HTMLTextAreaElement | null>,
): void {
	const wasActiveRef = useRef(false);

	useEffect(() => {
		if (!active) {
			wasActiveRef.current = false;
			return;
		}
		if (wasActiveRef.current) {
			return;
		}
		wasActiveRef.current = true;

		const id = requestAnimationFrame(() => {
			focusEditableControlAtStart(ref.current);
		});
		return () => cancelAnimationFrame(id);
	}, [active, ref]);
}
